<template>
  <div
    class="terms_item"
    :class="{ terms_item_other: type === AGREEMENT_TYPE.PROXY_CONSENT }"
  >
    <span class="form_element-checkbox">
      <input
        :id="type"
        v-model="termsAgreed"
        type="checkbox"
        @change="onChange"
      />
      <label :for="type" class="sp_chk focus">{{ title }}</label>
    </span>
    <template v-if="this.showAll">
      <a
        :class="[
          type === AGREEMENT_TYPE.VCALL_PRIVACY || type === AGREEMENT_TYPE.VCALL_RESEVE
            ? 'check-list__detail'
            : 'unfold',
        ]"
        data-layer="privacy-layer"
        @click="onTerms"
        >전체보기 <i class="icon-exports"
      /></a>
      <modal-terms ref="refModal">
        <slot />
      </modal-terms>
    </template>
  </div>
</template>
<script>
import ModalTerms from "@/components/modal-popups/ModalTerms.vue";
import { AGREEMENT_TYPE } from "@/utils/constants";
import Template from "@/views/Template.vue";

export default {
  name: "AgreementTerms",
  components: {
    ModalTerms,
    Template,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      termsAgreed: this.value,
    };
  },
  watch: {
    value() {
      if (this.value === true) {
        this.termsAgreed = true;
      } else {
        this.termsAgreed = false;
      }
    },
  },
  computed: {
    AGREEMENT_TYPE() {
      return AGREEMENT_TYPE;
    },
  },
  methods: {
    onChange() {
      if (this.termsAgreed) {
        this.onTerms();
      }

      this.$emit("input", this.termsAgreed);
      this.$emit("change", {
        type: this.type,
        accepted: this.termsAgreed,
      });
    },
    onTerms() {
      if (this.$refs.refModal) {
        this.$refs.refModal.open();
      }
    },
  },
};
</script>

<style scoped>
.terms_option {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/agreement/main/partial/AgreementTerms.vue